/**
 * Google Analytics 4 bootstrap.
 *
 * The measurement ID comes from the Lovable Google Analytics connector
 * (VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY) so the connected GA4
 * account is always the one receiving data — no hardcoded IDs.
 */
export const GA_MEASUREMENT_ID: string | undefined =
  import.meta.env.VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY;

let initialized = false;

export function initGA4(): void {
  if (initialized || typeof window === 'undefined') return;

  if (!GA_MEASUREMENT_ID) {
    console.warn('[GA4] No measurement ID configured — skipping Google Analytics.');
    return;
  }

  initialized = true;

  const start = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    }
    window.gtag = window.gtag || gtag;
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  };

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}
